import _ from 'underscore';

/* global REACH */

/**
 * provides an implementation of _generateAndGetHardwareId that returns a
 * device-specific hardware ID based on physical network addresses (MAC
 * addresses) or attached wired and wireless network adapters.
 *
 * resulting ID is stable and normalized provided the device has the same wired
 * and wireless network adapters visible to the C# application.
 *
 * @mixin ReachPlayerHardwareIdGeneratorMixin
 */
var ReachPlayerHardwareIdGeneratorMixin = function () {
    /**
     * returns a resolved promise which returns the hardware ID
     *
     * @method _generateAndGetHardwareId
     * @return {Promise<string>}
     * @memberOf ReachPlayerHardwareIdGeneratorMixin
     */
    this._generateAndGetHardwareId = function () {
        var hardwareId = _.chain(REACH.Host.GetPhysicalAddresses())
            .map(function (a) {
                return a.toLocaleLowerCase();
            }) //lowercase all addresses
            .sortBy(function (a) {
                return a;
            }) //sort alphabetically
            .reduce(function (memo, a) {
                return memo + a;
            }) //concatenate them all
            .value(); //return string

        return Promise.resolve('REACH://' + hardwareId);
    };
};

export { ReachPlayerHardwareIdGeneratorMixin };
